import { IconArrowright } from '@/assets/images';
import { AppIcon, AppText } from '@/components';
import PropTypes from 'prop-types';
import './ActionItem.scss';

/**
 * A reusable standalone component for displaying menu options, settings items,
 * or interactive list rows.
 * Supports left icons, middle text, and custom trailing components (defaulting to a right arrow).
 */
const ActionItem = ({
   label,
   icon: Icon,
   onClick,
   className = '',
   trailing,
   variant = 'default', // 'default' | 'danger'
   showTrailingArrow = true,
   as: Component = 'button',
}) => {
   return (
      <Component
         className={`actionItem ct-flex ct-aiCenter ct-gap10 variant-${variant} ${className}`}
         onClick={onClick}
         type={Component === 'button' ? 'button' : undefined}
      >
         {Icon && (
            <div className="actionItemIcon ct-icon ">
               <AppIcon className="ct-lg" icon={<Icon />} />
            </div>
         )}

         <AppText as="div" className="actionItemLabel ct-flex1 ct-ellipsis">
            {label}
         </AppText>

         {(trailing || showTrailingArrow) && (
            <div className="actionItemChevron ct-icon ct-flex ct-jcEnd">
               {trailing || <AppIcon icon={<IconArrowright />} />}
            </div>
         )}
      </Component>
   );
};

ActionItem.propTypes = {
   label: PropTypes.node.isRequired,
   icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object]),
   onClick: PropTypes.func,
   className: PropTypes.string,
   trailing: PropTypes.node,
   variant: PropTypes.oneOf(['default', 'danger']),
   showTrailingArrow: PropTypes.bool,
   as: PropTypes.elementType,
};

export default ActionItem;
